import { hot } from 'react-hot-loader/root';
import * as React from 'react';
import Toast from '@public/toast.tsx';
import '@styles/app.scss';
import { StageDefault } from '@/context.ts';
import { fetch, StageInfoRsp } from '@/fetch.ts';
// import Apply from '@hooks/apply/index.tsx';
// import { ApplyDefault } from '@/applyContext.ts';
import Tab1and2 from '@hooks/act/tab1and2/index.tsx';
import Tab3 from '@hooks/act/tab3/index.tsx';
import Tab4 from '@hooks/act/tab4/index.tsx';

/* 引入头图一级 */
const Images = ['header', 'footer', '1', '1-1', '2', '2-1', '3', '3-1', '4', '4-1'].map((item: any) => require(`./assets/images/${item}.png`));
const images = [];
for (let i = 0; i < Images.length; i++) {
  images[i] = new Image();
  images[i].src = Images[i].default;
}
const { useState, useEffect } = React;
interface StyleType {
  width: string,
  height: string,
}
interface TabType {
  tabName: string,
  tabCurrent: number,
  openImg: any,
  closeImg: any,

}
/* 配置tab */
const tabs: TabType[] = [
  {
    tabName: 'tab1',
    tabCurrent: 1,
    openImg: Images[2].default,
    closeImg: Images[3].default,
  },
  {
    tabName: 'tab2',
    tabCurrent: 2,
    openImg: Images[4].default,
    closeImg: Images[5].default,
  },
  {
    tabName: 'tab3',
    tabCurrent: 3,
    openImg: Images[6].default,
    closeImg: Images[7].default,
  },
  {
    tabName: 'tab4',
    tabCurrent: 0,
    openImg: Images[8].default,
    closeImg: Images[9].default,
  },
];
const App: React.FC = () => {
  /* 防抖 */
  const debounce = (wait: number) => {
    let timer: any = null;
    return function () {
        if (timer) clearTimeout(timer);
        timer = setTimeout(function () {
          HeadStyle(styleCompute(960));
          FootStyle(styleCompute(628));
        }, wait);
    }
  }
  const styleCompute: (size: number) => StyleType = size => {
    let styleOutput: StyleType;
    styleOutput = {
      width: `${document.body.offsetWidth > 1300 ? document.body.offsetWidth : 1300}px`,
      height: `${((document.body.offsetWidth > 1300 ? document.body.offsetWidth : 1300) * size) / 1920}px`,
    }
    return styleOutput;
  }
  const [headStyle, HeadStyle] = useState<StyleType>(styleCompute(960));
  const [footStyle, FootStyle] = useState<StyleType>(styleCompute(628));
  useEffect(() => {
    window.onresize = debounce(500);
  }, [])

  /* tab状态 */
  const [tabList] = useState<TabType[]>(tabs);
  const [tabCurrent, TabCurrent] = useState<number>(0);
  const [iEntStage, set_iEntStage] = useState<number>(0);
  const [iGameStage, set_iGameStage] = useState<number>(0);
  useEffect(() => {
    // console.log = () => null;
    /* 获取赛程阶段 */
    fetch.StarGetStageInfo(
      {
        lPid: 0,
      }
    )
      .then((rsp: StageInfoRsp) => {
        // console.log('赛程阶段', JSON.stringify(rsp));
        let iEntStage_ = stageChange(rsp.iEntStage);
        let iGameStage_ = stageChange(rsp.iGameStage);
        set_iEntStage(iEntStage_);
        set_iGameStage(iGameStage_);
        if (iEntStage_ === 0) {
          TabCurrent(0);
        } else {
          if (iEntStage_ > 4 && iGameStage_ > 0) {
            TabCurrent(2);
          } else {
            TabCurrent(1);
          }
        }
      })
  }, [])
  const stageChange = (i: number) => {
    if (i === 0) return 0;
    if (i === 1 || i ===2) {
      return 1;
    } else if (i === 3 || i === 4) {
      return 2;
    } else if (i === 5) {
      return 3;
    } else if (i === 6 || i === 7){
      return 4;
    } else {
      return 5;
    }
  }
  /* toast开关 */
  const [showTabToast, ShowTabToast] = useState<string>('');
  const tabToastOpen: (text: string) => void = text => {
    ShowTabToast(text);
    setTimeout(() => {
      ShowTabToast('');
    }, 3000)
  }

  const [applyOpen, ApplyOpen] = useState<boolean>(false);
  const close: () => void = () => {
    ApplyOpen(false);
  }

  return (
    <div id="App">
      { showTabToast !== '' && <Toast text={showTabToast} />}
      <section className='app_bg'>
        { /* 页面头图或者动态头图 */ }
        {/* <img
          className='head_cover'
          src={Images[0].default}
          alt='头图'
          style={headStyle}
          id='top'
        /> */}
        <video
          className={'head_cover'}
          src={'https://diy-assets.msstatic.com/hyys/activity/202010NDTT2.mp4'}
          autoPlay={true}
          muted={true}
          loop={true}
          style={headStyle}
          poster={Images[0].default}
          id='top'
        />
        {/* <ApplyDefault.Provider
          value={{close}}
        >
          <Apply show={applyOpen} />
        </ApplyDefault.Provider> */}
        <div className='app_content'>
          {/* <div
            className='apply_btn'
            onClick={
              () => {
                ApplyOpen(true);
              }
            }
          ></div> */}
          { /* 页面tab切换逻辑 */ }
          <ul className='tabs'>
            {
              tabList.map((item: TabType) => (
                <li
                  key={item.tabName}
                  style={{
                    backgroundImage: `url(${tabCurrent === item.tabCurrent ? item.openImg  : item.closeImg})`,
                    cursor: `${tabCurrent === item.tabCurrent ? 'default'  : 'pointer'}`,
                  }}
                  onClick={
                    (): void => {
                      let judgeiGame = (iGameStage === 0 && item.tabCurrent === 2);
                      let judgeiEnt = (iEntStage === 0 && (item.tabCurrent === 1 || item.tabCurrent === 3));
                      if (judgeiGame || judgeiEnt) {
                        tabToastOpen('活动暂未开始，敬请期待');
                        return;
                      }
                      TabCurrent(item.tabCurrent);
                    }
                  }
                ></li>
              ))
            }
          </ul>
          <StageDefault.Provider
            value={
              {
                iEntStage: iEntStage,
                iGameStage: iGameStage,
                test: 0,
                tabToastOpen,
              }
            }
          >
            {
              /*
                这里根据iStage展示不同组件
              */
              [Tab4, Tab1and2, Tab1and2, Tab3].map((item: any, index: number): any => {
                if (index === tabCurrent) {
                  const COMP = item;
                  return <COMP key={index} index={tabCurrent}/>
                }
              })
            }
          </StageDefault.Provider>
        </div>
        { /* 页面底部背景 */ }
        <img
          className='foot_cover'
          alt='底部背景'
          src={Images[1].default}
          style={footStyle}
        />
      </section>
    </div>
  )
}

// 开启 webpack 的 HMR
export default hot(App);
